$(document).on('cart.requestComplete', function(event, cart) {
  dataLayer.push({'quantity': cart.item_count});
});

$('[data-header-slick]').slick({
  arrows: true,
  dots: false,
  prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
  nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
  autoplaySpeed: 4000,
  autoplay: true,
});

const $dropdownBtn = $('[data-dropdown-btn]');
$dropdownBtn.on('click',function() {
  $(this).next('[data-dropdown-target]').slideToggle();
});

function _throttle(cb, delay = 250) {
  let shouldWait = false
  return (...args) => {
    if (shouldWait) return
    cb(...args)
    shouldWait = true
    setTimeout(() => {
      shouldWait = false
    }, delay)
  }
}

const dialog = document.querySelector('[data-dialog]');
const overlay = document.querySelector('[data-overlay]');

function showDialog() {
  dialog.classList.add('active');
  dialog.querySelector('[data-dialog-content]').focus();
  overlay.classList.add('active');
}

function hideDialog() {
  dialog.className = 'dialog';
  overlay.classList.remove('active');
}

function initDialogHandlers() {
  [overlay].forEach(el => {
    el.addEventListener('click',() => {
      hideDialog();
    });
  });

  dialog.addEventListener('click',event => {
    const target = event.target;
    if (target.hasAttribute('data-close-dialog')) {
      hideDialog();
    }
  });
}

function initMenus() {
  var breakpoint = 1024;
  var $mobileMenuContainer = $('.mobile-menu-container');
  var $mobileMenuTrigger = $('.mobile-menu-trigger');

  $(function() {
    $('a[href*="#"]:not([href="#"])').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        var windowWidth = $(window).width();
        if (target.length) {
          if (windowWidth < breakpoint) {
            $('html, body').animate({
              scrollTop: target.offset().top - 59
            }, 800);
          } else {
            $('html, body').animate({
              scrollTop: target.offset().top - 100
            }, 800);
          }
          return false;
        }
      }
    });
  });
  /* $(document).on('click','.mobile-menu .has-dropdown .menu-item-link.dropdown-btn',function(e){
    e.preventDefault();
    var thisList = $(this).closest('.has-dropdown');
    thisList.toggleClass('active');
    thisList.find('.submenu').slideToggle();
  });*/

if (typeof dropdownLock === 'undefined') {
  var dropdownLock = false; 
}
// 1st Level Dropdown (Main Categories)
$(document).on('click touchstart', '.mobile-menu .has-dropdown .menu-item-link.dropdown-btn', function(e) {
    if (dropdownLock) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }

    if ($(e.target).closest('.hp-mobile-dropdown--menu').length || $(e.target).hasClass('hp-mobile-dropdown--menu')) {
        e.preventDefault();
        e.stopPropagation(); 

        dropdownLock = true;
        setTimeout(function() { dropdownLock = false; }, 400); 

        var thisList = $(this).closest('.has-dropdown');
        thisList.toggleClass('active');
        thisList.find('.submenu').first().stop(true, true).slideToggle(300);
        
        return false;
    }
});
// 2nd Level Dropdown (Grandchild/Sub-categories)
$(document).on('click touchstart', '.mobile-menu .has-dropdown .submenu-item-link.dropdown-btn', function(e) {
    if (dropdownLock) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }

    if ($(e.target).closest('.hp-mobile-sub-dropdown--menu').length || $(e.target).hasClass('hp-mobile-sub-dropdown--menu')) {
        e.preventDefault();
        e.stopPropagation();

        dropdownLock = true;
        setTimeout(function() { dropdownLock = false; }, 400);

        var thisList = $(this).closest('.has-dropdown');
        thisList.toggleClass('active');
        thisList.find('.grandchildmenu').first().stop(true, true).slideToggle(300);

        return false;
    }
});

  $(document).on('click','#menuTrigger',function() {
    $mobileMenuContainer.addClass('active');
    $mobileMenuTrigger.addClass('open');
  });

  $(document).on('click','#menuClose',function() {
    $mobileMenuContainer.removeClass('active');
    $mobileMenuTrigger.removeClass('open');
  });

  $(window).on('resize',function(){
    if($(window).width() > breakpoint){
      $mobileMenuContainer.removeClass('active');
    }
  });

  $(window).on('load scroll resize',function(){
    var $headerMain = $('.header-main');
    var heroHeight = $('.home-hero').outerHeight();
    var headerHeight = $headerMain.outerHeight();
    var triggerHeight = heroHeight - headerHeight;
    var scrollTop = $(window).scrollTop();
    if (scrollTop > triggerHeight) {
      $headerMain.addClass('showing');
    } else {
      $headerMain.removeClass('showing');
    }
  });

  if ($('.collection-all-btn').length) {
    $('[data-collection-all-btn]').on('click',function () {
      $(this).toggleClass('active');
      $('.collection-all-list-link').toggle();
    });
  }
}

function initSearch() {
  $('.js-show-search').on('click',function() {
    $('body').toggleClass('search-bar-active');
    $('.search-overlay').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e) {
      $('.search-bar-active .search-input').focus();
    });
    $('.mobile-menu-container').removeClass('active');
    $('.mobile-menu-trigger').removeClass('open');
  });

  $('[data-close-search]').on('click',function(){
    $('body').toggleClass('search-bar-active');
  });
}

const $searchInput = document.querySelector('[data-search-input]');
const $searchSuggestionEntry = document.querySelector('[data-search-entry]');

function clearSuggestions() {
  $searchSuggestionEntry.innerHTML = '';
}

function buildSuggestions(suggestions,$entryPoint,query) {
  let suggestionHtml = suggestions.map(product => {
    return `<li><a href="${product.url}"><img src="${product.image.replace('.jpg','_200x200.jpg')}" width="70" height="70" alt="${product.title}"/><div class="auto__content"><div class="auto__title">${product.title}</div><span class="auto__price">$${product.price}</span></div></a></li>`
  }).join('');
  suggestionHtml += `<a href="/search?q=${query}" class="search__autocomplete-action">See all results for <span>"${query}"</span> <i class="fa fa-angle-right"></i></a>`;
  $entryPoint.innerHTML = suggestionHtml;
}

function getSearchSuggestions(query,$entryPoint) {
  fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag`)
  .then(response => response.json())
  .then(suggestions => {
    const productSuggestions = suggestions.resources.results.products;
    if (productSuggestions.length > 0) {
      buildSuggestions(productSuggestions,$entryPoint,query);
    } else {
      clearSuggestions();
    }
  });
}

function initPredictiveSearch() {

  document.addEventListener('click',() => clearSuggestions());

  let timeout = null;
  $searchInput.addEventListener('input',function() {
    clearTimeout(timeout);
    const inputValue = this.value;
    timeout = setTimeout(function() {
      if (inputValue.length > 0) {
        getSearchSuggestions(inputValue,$searchSuggestionEntry);
      } else {
        clearSuggestions();
      }
    }, 150);
  });

};

document.addEventListener('DOMContentLoaded',() => {
  initMenus();
  initSearch();
  initDialogHandlers();
  initPredictiveSearch();

  $('a[href^="/account/logout"]').on("click", function () {
    $.ajax($(this).attr('href'))
      .done(function () {
        window.location.href = "/pages/the-prfct-shop";
      });
    return false;
  });
});

document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    hideDialog();
  }
});

class AccordionGroup extends HTMLElement {
  constructor() {
    super();
    this.controls = this.querySelectorAll('[data-dropdown-btn]');
    this.controls.forEach(btn => {
      btn.addEventListener('click', this.onControlClick.bind(this));
    });
  }
  onControlClick(event) {
    event.target.classList.toggle('active');
  }
}
customElements.define('accordion-group', AccordionGroup);

class BeforeAfter extends HTMLElement {

  constructor() {
    super();
    this.dialogEntry = document.querySelector('[data-dialog-entry]');
    this.beforeAfterPhotos = this.querySelectorAll('[data-before-after]');
    this.filterGroups = document.querySelector('[data-filter-group="desktop"]');
    this.filterGroupsMobile = document.querySelector('[data-filter-group="mobile"]');
    this.beforeAfterTreatment = this.querySelector('[data-treatment]');
    this.beforeAfterPhotos.forEach(button => button.addEventListener('click', this.handleClickBeforeAfter.bind(this)));
    this.buildFilterList('mobile', this.filterGroupsMobile);
    this.buildFilterList('desktop', this.filterGroups);
  }

  handleClickBeforeAfter(event) {
    this.buildBeforeAfterDialog(event.target.dataset);
    showDialog();
  }

  buildBeforeAfterDialog(data) {
    const url = data.photoUrl;
    const name = data.clientName;
    const duration = data.duration;
    const provider = data.provider;
    const treatment = data.beforeAfter;
    const services = data.services;
    const index = parseInt(data.setIndex);
    const setSize = parseInt(data.setSize);
    let prevIndex = (index - 1);
    let nextIndex = (index + 1);
    if (prevIndex == 0) prevIndex = setSize;
    if (nextIndex > setSize) nextIndex = 1;
    this.dialogEntry.innerHTML = `
      <div class="dialog__before-after">
        <img src="${url}" alt="${name}" width="800" height="800"/>
        <div class="before-after__client">${name}</div>
        <div class="before-after__detail">${services}</div>
        <div class="before-after__detail">${duration}</div>
        <div class="before-after__detail">Provider: ${provider}</div>
        <button type="button" data-previous-photo="${prevIndex}" data-photo-set="${treatment}"><i class="fa fa-angle-left"></i></button>
        <button type="button" data-next-photo="${nextIndex}" data-photo-set="${treatment}"><i class="fa fa-angle-right"></i></button>
      </div>
    `;
    this.dialogNavigationHandlers(this.dialogEntry);
  }

  dialogNavigationHandlers(dialog) {
    const component = this;
    dialog.querySelector('[data-previous-photo]').addEventListener('click',event => {
      const el = event.target;
      const prevIndex = event.target.dataset.previousPhoto;
      const treatment = el.dataset.photoSet;
      const newClient = document.querySelector(`[data-before-after="${treatment}"][data-set-index="${prevIndex}"]`);
      component.buildBeforeAfterDialog(newClient.dataset);
    });
    dialog.querySelector('[data-next-photo]').addEventListener('click',event => {
      const el = event.target;
      const nextIndex = event.target.dataset.nextPhoto;
      const treatment = el.dataset.photoSet;
      const newClient = document.querySelector(`[data-before-after="${treatment}"][data-set-index="${nextIndex}"]`);
      component.buildBeforeAfterDialog(newClient.dataset);
    });
  }

  buildFilterList(group, entry) {
    const list = entry.querySelector('ul');
    const treatment = this.beforeAfterTreatment.dataset.treatment;
    const handle = this.beforeAfterTreatment.dataset.treatmentHandle;
    list.insertAdjacentHTML('beforeend',`
      <li>
        <label for="filter-${handle}-${group}"><input type="checkbox" id="filter-${handle}-${group}" value=".treatment__${handle}">${treatment}</label>
      </li>
    `);
  }
}
customElements.define('before-and-after', BeforeAfter);